import {SET, UPDATE_CURRENT} from "./actionTypes";

export function setProgress(progress) {
  return {
    type: SET,
    progress
  }
}

export function updateCurrent(value) {
  return dispatch => {
    dispatch({
      type: UPDATE_CURRENT,
      value
    });
  };
}